import { Product } from "../../app/shared/interface/home";

export interface WishlistState {
  products: Product[];
  loading: boolean;
      ids: string[];
}




export const initialWishlistState: WishlistState = {
    products: [],
  loading: false,
ids:  []
};